import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BaseComponent } from 'app/_components/base.component';

import { AuthenticationService, CompanyService } from 'app/_services';

import { DATE_TIME_SUB_TYPE, REQUEST_FORM_SUB_TYPE, MULTIPLE_RADIO_EVENT_DETAIL_SUB_TYPE, NUMBER_SUB_TYPE } from 'app/app.constants';

@Component({
  selector: 'app-request-question-row-create',
  templateUrl: './request-question-row-create.component.html',
})
export class RequestQuestionRowCreateComponent extends BaseComponent implements OnInit {
  DATE_TIME_SUB_TYPE = DATE_TIME_SUB_TYPE;
  REQUEST_FORM_SUB_TYPE = REQUEST_FORM_SUB_TYPE;
  MULTIPLE_RADIO_EVENT_DETAIL_SUB_TYPE = MULTIPLE_RADIO_EVENT_DETAIL_SUB_TYPE;
  NUMBER_SUB_TYPE = NUMBER_SUB_TYPE;
  @Input() priority: string;
  @Input() questions: any[];
  @Input() newQuestion: any;
  @Input() questionTypes: any[];
  @Input() dedicatedQuestionTypes: any[];
  @Input() nextScreens: any[];
  @Input() depth: number;
  @Input() meetingTypes: any[] = [];
  @Input() alignedMeetingTypes: any[] = [];
  @Input() programSeriesOptions: any[] = [];
  @Input() formatOptions: any[] = [];
  @Input() speakerCountOptions: any[] = [];

  subQuestion: any;

  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
    private toastr: ToastrService,
  ) {
    super(router, authenticationService, companyService);
  }

  ngOnInit() {

  }

  resetNewQuestion() {
    this.newQuestion = {
      type_id: null,
      sub_type: null,
      text: '',
      packages: null,
      equipments: null,
      min: 1,
      max: 1,
      skipScreen: -1,
      subQuestions: []
    };
  }

  onAddNewQuestion() {
    if (!this.newQuestion.type_id) {
      this.toastr.error('Question Type is missing!');
      return;
    }
    if (this.newQuestion.type_id === 'MULTIPLE_RADIO' && this.newQuestion.sub_type) {
      const list = this.getRadioChoiceList(this.newQuestion);
      if (list.length === 0) {
        this.toastr.error('Multiple Radio with a Sub Question Type must have at least one option. Click "Load options" first.');
        return;
      }
    }
    if (this.newQuestion.min) this.newQuestion.min = +this.newQuestion.min;
    if (this.newQuestion.max) this.newQuestion.max = +this.newQuestion.max;
    if (this.newQuestion.min_attendee) this.newQuestion.min_attendee = +this.newQuestion.min_attendee;
    this.questions.push(this.newQuestion);
    this.newQuestion.rank = this.questions.length;
    this.resetNewQuestion();
  }

  hasDedicatedQuestion() {
    return !!this.questions.find(q => this.dedicatedQuestionTypes.includes(q.type_id));
  }

  needOptionalCheckbox(question) {
    return question.type_id === 'AMOUNT' || question.type_id === 'CHECKBOX'
      || question.type_id === 'TEXT_FIELD' || question.type_id === 'PHONE_NUMBER'
      || question.type_id === 'EMAIL'
      || question.type_id === 'TEXT_AREA' || question.type_id === 'state'
      || question.type_id === 'NUMBER' || question.type_id === 'FILE'
      || question.type_id === 'meal_type';
  }

  hasRadioEventDetailSubType(question: any): boolean {
    return question && question.type_id === 'MULTIPLE_RADIO' && question.sub_type;
  }

  getRadioEventDetailFullOptions(question: any): { value: string; label: string }[] {
    if (!question || question.type_id !== 'MULTIPLE_RADIO' || !question.sub_type) return [];
    switch (question.sub_type) {
      case 'event_type':
        return (this.meetingTypes || []).map((m: any) => ({ value: String(m.id), label: m.name || String(m.id) }));
      case 'program_series':
        return (this.programSeriesOptions || []).map((s: any) => ({
          value: s.value != null ? String(s.value) : (s.id != null ? String(s.id) : ''),
          label: s.label || s.name || String(s.value != null ? s.value : s.id || '')
        }));
      case 'attendee_format':
      case 'speaker_format':
        return (this.formatOptions || []).map((f: any) => ({ value: f.value, label: f.label || f.value }));
      case 'speaker_count':
        return (this.speakerCountOptions || []).map((c: any) => ({
          value: String(c.value),
          label: c.label || String(c.value)
        }));
      default:
        return [];
    }
  }

  onRadioSubTypeChange(question: any) {
    if (!question || question.type_id !== 'MULTIPLE_RADIO') return;
    const opts = this.getRadioEventDetailFullOptions(question);
    question.choices = opts.map(o => (o.value === o.label ? o.value : `${o.value}|${o.label}`)).join('\n');
  }

  getRadioChoiceList(question: any): { value: string; label: string }[] {
    if (!question || !question.choices || typeof question.choices !== 'string') return [];
    return question.choices.split('\n').filter((line: string) => line.trim()).map((line: string) => {
      const t = line.trim();
      const i = t.indexOf('|');
      if (i >= 0) return { value: t.substring(0, i).trim(), label: t.substring(i + 1).trim() || t };
      return { value: t, label: t };
    });
  }

  removeRadioChoice(question: any, index: number) {
    const list = this.getRadioChoiceList(question);
    if (list.length <= 1) return;
    list.splice(index, 1);
    question.choices = list.map(o => (o.value === o.label ? o.value : `${o.value}|${o.label}`)).join('\n');
  }
}
